import create from 'zustand';

import { BillingDetails, getBillingDetails as getBillingDetailsAPI } from '@/features/billing';
import { getAllAxiosData, GetterAxios } from '@/lib/axios';

type UserBillingDetailsHook = {
  billingDetails: BillingDetails;
  isSet: boolean;
  initBillingDetails: (groupId: string) => void;
  setBillingDetails: (billingDetails: BillingDetails) => void;
  getBillingDetails: () => BillingDetails;
  isBillingDetailsSet: () => boolean;
  groupId: string;
};

const defaultBillingDetails: BillingDetails = {
  address: '',
  alreadySaved: false,
  city: '',
  companyCif: '',
  companyCifDocumentType: '',
  companyName: '',
  countryId: '',
  createdAt: '',
  currency: null,
  groupId: '',
  id: '',
  lastname: '',
  name: '',
  phone: '',
  postalCode: '',
  provinceId: '',
};

export const useGroupBillingDetails = create<UserBillingDetailsHook>((set, get) => {
  const getBillingDetails = (): BillingDetails => get().billingDetails;

  const setBillingDetails = (billingDetails: BillingDetails) =>
    set(() => ({ isSet: true, billingDetails: billingDetails }));

  const setGroupId = (groupId: string) => {
    set(() => ({ groupId }));
  };

  const initBillingDetails = (groupId: string) => {
    const getters: GetterAxios[] = [{ callback: getBillingDetailsAPI, parameters: { groupId } }];
    const setters: any = [setBillingDetails];

    setGroupId(groupId);

    getAllAxiosData(getters, setters).then(() => {
      // Nothing to do here
    });
  };
  const isBillingDetailsSet = (): boolean => {
    return get().isSet;
  };

  return {
    groupId: '',
    billingDetails: defaultBillingDetails,
    isSet: false,
    initBillingDetails,
    setBillingDetails,
    getBillingDetails,
    isBillingDetailsSet,
  };
});
